export default __webpack_public_path__ + "static/media/instagram.b79433a6.png";